import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { addPersonsInvolved, ChecklistCategoriesVM, ChecklistQuestionsVM, ContractorsVM, FormsByCategory_Dashboard, IdNameVM, InspectionVM, MonthlyDashboardMessageVM, MonthlyHoursVM, ObservationDetailsDomain, ObservationVMwithState, OverallDashboardVM, SafetyObservationsDashboardVM, saveImageVM, SiteCodeDetails, SiteCodes, Task5Model, ToolboxTalkModel, UsersVM, WorkAreasByDepartmentVM } from '../entities/global/model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Tuple } from '../setup-equipment/setup-equipment.model';


@Injectable()
export class SafetyGeneraldashboardService {

  constructor(private _http: Http) { }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
}

public GetOverallDashboard(Id: number, stateID:number ): Observable<OverallDashboardVM> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  return this._http.get('Api/SafetyDashboard/GetOverallDashboard', { search: params }).share().map(
      (response: Response) => <OverallDashboardVM>response.json()).catch(this.handleError);
}

public GetMonthsForDashboard(): Observable<IdNameVM[]> {
  return this._http.get('api/SafetyDashboard/GetMonthsForDashboard').share().map(
    (response: Response) => <IdNameVM[]>response.json()).catch(this.handleError);
}
public GetSafetyChecklistDashboard(Id: number, stateID:number, inputValueSefetyObservation:number ): Observable<SafetyObservationsDashboardVM> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  params.set('observationTypeId', inputValueSefetyObservation.toString());
  return this._http.get('Api/SafetyDashboard/GetSafetyChecklistDashboard', { search: params }).share().map(
      (response: Response) => <SafetyObservationsDashboardVM>response.json()).catch(this.handleError);
}


// public GetTRIFRForLast12Months(): Observable<Tuple> {
//   return this._http.get('api/SafetyDashboard/GetTRIFRForLast12Months').share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }



public GetTRIFRForLast12Months(stateID: number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', "" + stateID);
  return this._http.get('api/SafetyDashboard/GetTRIFRForLast12Months', { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}



// public GetObservationQuestionMonthlyhours(): Observable<Tuple> {
//   return this._http.get('api/SafetyDashboard/GetObservationQuestionMonthlyhours').share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }


public GetObservationQuestionMonthlyhours(stateID: number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', "" + stateID);
  return this._http.get('api/SafetyDashboard/GetObservationQuestionMonthlyhours', { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

// public GetTRIFRIncidentsForLast12Months(): Observable<Tuple> {
//   return this._http.get('api/SafetyDashboard/GetTRIFRIncidentsForLast12Months').share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }

public GetTRIFRIncidentsForLast12Months(stateID: number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', "" + stateID);
  return this._http.get('api/SafetyDashboard/GetTRIFRIncidentsForLast12Months', { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

// public GetHRFRForLast12Months(): Observable<Tuple> {
//   return this._http.get('api/SafetyDashboard/GetHRFRForLast12Months').share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }

public GetHRFRForLast12Months(stateID: number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', "" + stateID);
  return this._http.get('api/SafetyDashboard/GetHRFRForLast12Months', { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public CreateNewInspection(model: ObservationDetailsDomain): Observable<number> {
  return this._http.post("api/SafetyDashboard/CreateNewInspection", model).share().map(
    (response: Response) => <number>response.json()).catch(this.handleError);
}
public GetActiveWorkAreasForDropDownList(): Observable<WorkAreasByDepartmentVM[]> {
  return this._http.get('api/SafetyDashboard/GetActiveWorkAreasForDropDownList').share().map(
    (response: Response) => <WorkAreasByDepartmentVM[]>response.json()).catch(this.handleError);
}

public GetInspectionDetail(ID:number ): Observable<InspectionVM> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ID', ID.toString());
  return this._http.get('Api/SafetyDashboard/GetInspectionDetail', { search: params }).share().map(
      (response: Response) => <InspectionVM>response.json()).catch(this.handleError);
}

// public GetInspectionState(Id:number): Observable<number> {
//   let params: URLSearchParams = new URLSearchParams();
//   params.set('Id', Id.toString());
//   return this._http.get("api/SafetyDashboard/GetInspectionState", { search: params }).share().map(
//     (response: Response) => <number>response.json()).catch(this.handleError);
// }


public GetContarctorsForSafetyApp(): Observable<ContractorsVM[]> {
  return this._http.get('api/SafetyDashboard/GetContarctorsForSafetyApp').share().map(
    (response: Response) => <ContractorsVM[]>response.json()).catch(this.handleError);
}


public GetinspectionSiteForSafetyApp(ID:number): Observable<ObservationVMwithState> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('ID', ID.toString());
  return this._http.get('api/SafetyDashboard/GetInspectionStatefordashboard', { search: params }).share().map(
    (response: Response) => <ObservationVMwithState>response.json()).catch(this.handleError);
}

public ToggleFollowUpRequired(Id:number , Required:boolean): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', "" + Id);
  params.set('Required', "" + Required);
  return this._http.get("api/SafetyDashboard/ToggleFollowUpRequired", { search: params } ).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}
public ToggleFollowUpCompleted(Id:number , Completed:boolean): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', "" + Id);
  params.set('Completed', "" + Completed);
  return this._http.get("api/SafetyDashboard/ToggleFollowUpCompleted", { search: params } ).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}
public ToggleSafeUnsafe(Id:number , safeOrUnsafe:number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', "" + Id);
  params.set('safeOrUnsafe', "" + safeOrUnsafe);
  return this._http.get("api/SafetyDashboard/ToggleSafeUnsafe", { search: params } ).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}
public ToggleChangeNotApplicable(CategoryId: number, InspectionId: number , SelectNA:boolean): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('CategoryId', "" + CategoryId);
  params.set('InspectionId', "" + InspectionId);
  params.set('SelectNA', "" + SelectNA);
  return this._http.get("api/SafetyDashboard/ToggleChangeNotApplicable", { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}



public SaveQuestionComments(Id: number, ActionObserved:string, Responsibility:string, FollowUpActions:string): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id' , ""+Id.toString());
  params.set('ActionObserved', ""+ ActionObserved);
  params.set('Responsibility', "" +Responsibility);
  params.set('FollowUpActions', ""+ FollowUpActions);
  return this._http.get("api/SafetyDashboard/SaveQuestionComments", { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public SaveQuestionImage(params: saveImageVM): Observable<Tuple> {
  return this._http.post("api/SafetyDashboard/SaveQuestionImage", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public SaveContractorsInvolved(Id: number, CompanyName:string, StaffName:string): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id' , Id.toString());
  params.set('CompanyName',  CompanyName);
  params.set('StaffName',  StaffName)
  return this._http.get("api/SafetyDashboard/SaveContractorsInvolved", { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}

public SaveWorkArea(Id: number, WorkArea:number): Observable<Tuple> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', "" + Id);
  params.set('WorkArea', "" + WorkArea);

  return this._http.get("api/SafetyDashboard/SaveWorkArea", { search: params }).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}


public GetUsersForSafetyApp(): Observable<UsersVM[]> {
  return this._http.get('api/SafetyDashboard/GetUsersForSafetyApp').share().map(
    (response: Response) => <UsersVM[]>response.json()).catch(this.handleError);
}

// public SavePersonsInvolved(Id:number, PersonsInvolved:number[]): Observable<Tuple> {
//   let params: URLSearchParams = new URLSearchParams();
//   params.set('Id', "" + Id.toString());
//   params.set('PersonsInvolved', PersonsInvolved.toString());

//   return this._http.get("api/SafetyDashboard/SavePersonsInvolved", { search: params }).share().map(
//     (response: Response) => <Tuple>response.json()).catch(this.handleError);
// }
public SavePersonsInvolved(params: addPersonsInvolved): Observable<Tuple> {
  return this._http.post("api/SafetyDashboard/SavePersonsInvolved", params).share().map(
    (response: Response) => <Tuple>response.json()).catch(this.handleError);
}


public GetFormsByCategoryDashboard(Id: number, stateID:number,formCategoryID:number ): Observable<FormsByCategory_Dashboard[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  params.set('formCategoryID', formCategoryID.toString());
  return this._http.get("api/SafetyDashboard/GetFormsByCategoryDashboard",{ search: params }).share().map(
    (response: Response) => <FormsByCategory_Dashboard[]>response.json()).catch(this.handleError);
}


public GetIncidentsDashboard(Id: number, stateID:number,IncidentTypeID:number ): Observable<FormsByCategory_Dashboard[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  params.set('IncidentTypeID', IncidentTypeID.toString());
  return this._http.get("api/SafetyDashboard/GetIncidentsDashboard",{ search: params }).share().map(
    (response: Response) => <FormsByCategory_Dashboard[]>response.json()).catch(this.handleError);
}

public GetLastLTIDashboard(Id: number, stateID:number ): Observable<FormsByCategory_Dashboard[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  return this._http.get("api/SafetyDashboard/GetLastLTIDashboard",{ search: params }).share().map(
    (response: Response) => <FormsByCategory_Dashboard[]>response.json()).catch(this.handleError);
}

public GetLastMTIDashboard(Id: number, stateID:number ): Observable<FormsByCategory_Dashboard[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('Id', Id.toString())
  params.set('stateID', stateID.toString());
  return this._http.get("api/SafetyDashboard/GetLastMTIDashboard",{ search: params }).share().map(
    (response: Response) => <FormsByCategory_Dashboard[]>response.json()).catch(this.handleError);
}

public GetLastMTIAndLTI( stateID:number ): Observable<FormsByCategory_Dashboard[]> {
  let params: URLSearchParams = new URLSearchParams();
  params.set('stateID', stateID.toString());
  return this._http.get("api/SafetyDashboard/GetLastMTIAndLTI",{ search: params }).share().map(
    (response: Response) => <FormsByCategory_Dashboard[]>response.json()).catch(this.handleError);
}



public getHomeScreenImage(): Observable<string> {
    
  return this._http.get("api/SafetyDashboard/getHomeScreenImage").share().map(
    (response: Response) => <string>response.json()).catch(this.handleError);
}

}
